<template>
  <div class="addressList search">
    <header>
      <form action="/">
        <van-search
          v-model="searchValue"
          placeholder="搜索"
          show-action
          clearable
          maxlength="32"
          @search="search"
          @cancel="cancel"
        />
      </form>
      <!--<span @click="cancel">取消</span>-->
    </header>
    <van-radio-group v-if="list && list.length > 0" v-model="radio">
      <ul>
        <li v-for="(item, index) of list" :key="index">
          <van-radio :name="index" checked-color="#FC0324" icon-size="18">
            <div class="address">
              <p>
                <span class="firstSpan" @click="choose(item, index)">
                  {{ item.name }}&nbsp;&nbsp;&nbsp;{{ item.mobile }}
                  <img v-if="item.isdefault === '1'" src="../../assets/images/default.png" />
                </span>

                <span class="lastSpan" @click="editor(item)">
                  编辑
                  <van-icon name="arrow" size="10" />
                </span>
              </p>
              <b @click="choose(item, index)">{{ item.area + '' + item.address }}</b>
            </div>
          </van-radio>
        </li>
      </ul>
    </van-radio-group>
    <footer class="footerIOS" v-if="list && list.length > 0">
      <button class="redBtn" v-if="!!list && list.length < 50" @click="add">添加收货地址</button>
      <button class="btnGray" v-else-if="!!list && list.length >= 50">添加收货地址</button>
    </footer>
    <div ref="noaddress" v-if="noAddress" style="height: 100%">
      <empty :path="'noAddress'"></empty>
    </div>
    <van-dialog
      v-model="showmsg"
      class="van-flod-dialog"
      title="修改地址"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog" v-html="dialogHtml"></div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleCancel">取消</van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleOk">确认</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import { isApp, isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'addressChoose',
  data() {
    return {
      showmsg: false,
      radio: null,
      list: [],
      dialogHtml: '',
      freightdiff: 0,
      address: {},
      noAddress: false,
      searchValue: '',
      isAjax: 0
    }
  },
  components: {
    empty
  },
  mounted: function() {
    if (isWeixin()) {
      fenxiang({ path: 'addresschoose' })
    }
    this.getData()
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    radio(n) {
      console.log('radio', n)
    }
  },
  methods: {
    getData: function() {
      var url = this.$ajax.getAddressList_URL + '?keywords=' + this.searchValue
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.list = res.data.addresslist
          if (res.data.addresslist.length > 0) {
            that.noAddress = false
            // if (that.$route.query.chooseid != undefined && that.$route.query.chooseid != null) {
            //   that.radio = that.$route.query.chooseid
            // } else {
            for (var i = 0; i < that.list.length; i++) {
              if (that.list[i].id === that.$route.query.addressid) {
                that.radio = i
                break
              }
            }
            // }
          } else {
            that.noAddress = true
          }
        }
      })
    },
    handleCancel: function() {
      this.showmsg = false
    },
    handleOk: function() {
      if (this.freightdiff > 0) {
        let diffUrl = this.$ajax.confirmSupplementFreight_URL()
        let diffdata = {
          addressid: this.address.id,
          orderid: this.$route.query.orderid
        }
        if (this.isAjax == 1) return
        this.isAjax = 1
        this.$customRequestAjax
          .post(diffUrl, diffdata)
          .then((res) => {
            if (res.data.code === 200) {
              localStorage.setItem('currentAddress', window.location.href)
              this.$router.replace({
                path: '/pay',
                query: {
                  id: this.$route.query.orderid,
                  virtualorderid: res.data.virtualorderid,
                  money: parseFloat(this.freightdiff).toFixed(2)
                }
              })
            }
          })
          .finally(() => {
            this.isAjax = 0
          })
      } else if (this.freightdiff < 0) {
        let diffUrl = this.$ajax.confirmRefundFreight_URL()
        let diffdata = {
          addressid: this.address.id,
          orderid: this.$route.query.orderid
        }
        this.$customRequestAjax.post(diffUrl, diffdata).then((res) => {
          if (res.data.code === 200) {
            this.$router.replace({
              path: '/orderdetails',
              query: {
                id: this.$route.query.orderid
              }
            })
          }
        })
      }
    },
    isaddressFn: function(item) {
      var that = this,
        url = this.$ajax.checkAddress_URL + '?addressid=' + item.id
      return new Promise(function(resolve, reject) {
        that
          .$customRequestAjax(url)
          .then(function(res) {
            if (res.data.code == 200) {
              if (res.data.isareacode == 0) {
                that.$toast({
                  message: '为保证包裹派件正确，请重新更正地址',
                  duration: 3000,
                  onClose: function() {
                    that.editor(item)
                  }
                })
              } else {
                resolve(res)
              }
            } else {
              resolve(res)
            }
          })
          .catch(function(err) {
            resolve(res)
          })
      })
    },
    choose: function(items, idx) {
      this.radio = idx
      var arg = isApp()
      this.isaddressFn(items).then((res) => {
        var query = this.$route.query
        sessionStorage.setItem('choose_address', JSON.stringify(items))
        switch (this.$route.query.type) {
          case 'submsjkjorder':
            window.location.replace(
              '/static/wx/html/499/actorder.html?addressid=' +
                items.id +
                '&actid=' +
                this.$route.query.actid +
                '&itemid=' +
                this.$route.query.itemid +
                arg
            )
            break
          case 'submitfporder':
            window.location.replace(
              '/static/wx/html/actorder.html?addressid=' +
                items.id +
                '&actid=' +
                this.$route.query.actid +
                arg
            )
            break
          case 'submitcollageorder':
            window.location.replace(
              '/static/wx/html/new-group/collage_order.html?addressid=' +
                items.id +
                '&ptid=' +
                this.$route.query.gid +
                '&code=' +
                this.$route.query.code +
                arg
            )
            break
          case 'submitjoincollageorder':
            window.location.replace(
              '/static/wx/html/new-group/joincollage_order.html?addressid=' +
                items.id +
                '&gid=' +
                this.$route.query.gid +
                '&code=' +
                this.$route.query.code +
                arg
            )
            break
          case 'submitorder':
            query.chooseid = idx
            query.addressid = items.id
            this.$router.replace({
              path: '/order',
              query: query
            })
            break
          case 'submitorderprize':
            this.$router.replace({
              path: '/orderprize',
              query: {
                chooseid: idx,
                addressid: items.id
              }
            })
            break
          case 'orderdetails':
            if (this.$route.query.transfee && this.$route.query.items) {
              if (
                (this.address && this.address.id != items.id) ||
                !this.dialogHtml ||
                !this.address
              ) {
                var freightUrl
                if (this.$route.query.activitytype != 0) {
                  freightUrl =
                    this.$ajax.calculateActFreight_URL +
                    '?activitytype=' +
                    this.$route.query.activitytype +
                    '&addressid=' +
                    items.id +
                    '&groupid=' +
                    this.$route.query.activityid +
                    '&orderid=' +
                    this.$route.query.orderid
                } else {
                  freightUrl =
                    this.$ajax.calculateFreight_URL +
                    '?addressid=' +
                    items.id +
                    '&itemid=' +
                    this.$route.query.items +
                    '&buynum=' +
                    this.$route.query.nums +
                    '&orderid=' +
                    this.$route.query.orderid
                }
                this.$customRequestAjax.get(freightUrl).then((res) => {
                  if (res.data.code === 200) {
                    this.freightdiff = parseFloat(res.data.freight)
                    this.dialogHtml = ''
                    this.address = {}
                    /*
                      待支付订单编辑地址，
                      收运费时无需跳转支付，
                      直接返回订单详情，
                      订单详情接口直接带出运费金额
                    */
                    if (this.freightdiff > 0 && this.$route.query.orderstatus != 1) {
                      this.address = items
                      this.dialogHtml =
                        '您当前修改的地址为<span>【' +
                        items.area.split(' ')[0] +
                        '】</span>，需补交运费<span>【' +
                        parseFloat(this.freightdiff).toFixed(2) +
                        '元】</span>，是否确认修改？'
                      this.showmsg = true
                    } else if (this.freightdiff < 0 && this.$route.query.orderstatus != 1) {
                      this.address = items
                      this.dialogHtml =
                        '您当前修改的地址为<span>【' +
                        items.area.split(' ')[0] +
                        '】</span>，将为您退回<span>【' +
                        parseFloat(Math.abs(this.freightdiff)).toFixed(2) +
                        '元】</span>运费，稍后为您原路退回，是否确认修改？'
                      this.showmsg = true
                    } else {
                      var url = this.$ajax.updateOrderAddress_URL
                      var data = {
                        orderid: this.$route.query.orderid,
                        addressid: items.id,
                        gettername: items.name,
                        gettermobile: items.mobile,
                        getteraddress: items.area + ' ' + items.address
                      }
                      this.$customRequestAjax.post(url, data).then((res) => {
                        if (res.data.code === 200) {
                          this.$router.replace({
                            path: '/orderdetails',
                            query: {
                              id: this.$route.query.orderid,
                              status: 'success'
                            }
                          })
                        }
                      })
                    }
                  }
                })
              } else {
                this.showmsg = true
              }
            } else {
              var url = this.$ajax.updateOrderAddress_URL
              var data = {
                orderid: this.$route.query.orderid,
                addressid: items.id,
                gettername: items.name,
                gettermobile: items.mobile,
                getteraddress: items.area + ' ' + items.address
              }
              this.$customRequestAjax.post(url, data).then((res) => {
                if (res.data.code === 200) {
                  this.$router.replace({
                    path: '/orderdetails',
                    query: {
                      id: this.$route.query.orderid,
                      status: 'success'
                    }
                  })
                }
              })
            }
            break
          case 'submitIntegral':
            query.chooseid = idx
            query.addressid = items.id
            this.$router.replace({
              path: '/addOrderIntegral',
              query: query
            })
            break
          case 'vipgiftbagsubmitorder':
            query.chooseid = idx
            query.addressid = items.id
            this.$router.replace({
              path: '/vipgiftbagaddorder',
              query: query
            })
        }
      })
      // console.log(this.radio)
    },
    editor: function(items) {
      var arg = isApp()
      var query = this.$route.query
      console.log(arg)
      switch (this.$route.query.type) {
        case 'submitcollageorder':
          query.ordertype = 'submitcollageorder'
          query.id = items.id
          this.$router.replace({
            path: '/editadd?type=choose' + arg,
            query: query
          })
          break
        case 'submitjoincollageorder':
          query.ordertype = 'submitjoincollageorder'
          query.id = items.id
          this.$router.replace({
            path: '/editadd?type=choose' + arg,
            query: query
          })
          break
        case 'submsjkjorder':
          query.ordertype = 'submsjkjorder'
          query.id = items.id
          this.$router.replace({
            path: '/editadd??type=choose' + arg,
            query: query
          })
          break
        case 'submitfporder':
          query.ordertype = 'submitfporder'
          query.id = items.id
          this.$router.replace({
            path: '/editadd?type=choose' + arg,
            query: query
          })
          break
        case 'submitorder':
          query.type = 'choose'
          query.ordertype = 'submitorder'
          query.id = items.id
          this.$router.replace({
            path: '/editadd',
            query: query
          })
          break
        case 'submitIntegral':
          query.type = 'choose'
          query.ordertype = 'submitIntegral'
          query.id = items.id
          this.$router.replace({
            path: '/editadd',
            query: query
          })
          break
        case 'submitorderprize':
          query.type = 'choose'
          query.ordertype = 'submitorderprize'
          query.id = items.id
          this.$router.replace({
            path: '/editadd',
            query: query
          })
          break
        case 'orderdetails':
          query.type = 'choose'
          query.ordertype = 'orderdetails'
          query.id = items.id
          this.$router.replace({
            path: '/editadd',
            query: query
          })
          break
        case 'vipgiftbagsubmitorder':
          query.type = 'choose'
          query.ordertype = 'vipgiftbagsubmitorder'
          query.id = items.id
          this.$router.replace({
            path: '/editadd',
            query: query
          })
          break
      }
    },
    add: function() {
      var arg = isApp()
      var query = this.$route.query
      query.ordertype = this.$route.query.type
      query.type = 'choose'
      if (this.$route.query.type) {
        this.$router.replace({
          path: '/addadd?1=1' + arg,
          query: query
        })
      }
    },
    search: function() {
      this.getData()
    },
    cancel: function() {
      if (sessionStorage.getItem('order_history_num') == 3) {
        this.$router.go(-3)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.addressList ul li .address p,
.addressList ul li .address p span:first-of-type,
.addressList ul li .address p span:last-of-type {
  display: flex;
  display: -webkit-flex;
  display: -o-flex;
  display: -moz-flex;
  display: -ms-flex;
  align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
}
.addressList {
  header {
    padding-left: 0.1rem;
    background: #fff;
  }
  ul {
    padding-bottom: 0.73rem;
    li {
      padding: 0.15rem 0.12rem 0.15rem 0.16rem;
      background: #fff;
      margin-top: 0.1rem;
      .address {
        p {
          justify-content: space-between;
          -webkit-justify-content: space-between;
          -o-justify-content: space-between;
          -moz-justify-content: space-between;
          -ms-justify-content: space-between;
          margin-bottom: 0.04rem;
          .firstSpan {
            font-size: 0.16rem;
            font-weight: 600;
            color: rgba(34, 34, 34, 1);
            line-height: 0.22rem;
            img {
              width: 0.2rem;
              height: 0.12rem;
              margin-left: 0.05rem;
            }
          }
          .lastSpan {
            font-size: 0.12rem;
            /*font-family:PingFangSC;*/
            white-space: nowrap;
            font-weight: 400;
            color: rgba(29, 30, 30, 1);
            line-height: 0.17rem;
          }
        }
        b {
          display: block;
          height: 0.34rem;
          font-size: 0.12rem;
          /*font-family:'PingFangSC';*/
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 0.17rem;
          margin-right: 0.63rem;
        }
      }
    }
  }
  footer {
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.1rem 0.11rem;
    button {
      margin-bottom: 0.1rem;
    }
    .redBtn {
      width: 100%;
      height: 0.43rem;
      border: none;
      outline: none;
      display: block;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      background: -webkit-linear-gradient(
        90deg,
        rgba(252, 3, 36, 1) 0%,
        rgba(246, 58, 102, 1) 100%
      );
      border-radius: 25px;
      font-size: 0.17rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 0.24rem;
    }
    .btnGray {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color: #ffffff;
      width: 100%;
      height: 100%;
      background: #dddddd;
    }
  }
}
.van-flod-dialog {
  width: 70%;
  .floddialog {
    padding: 0.2rem 0.15rem;
    padding-bottom: 0.1rem;
    text-align: center;
    font-size: 0.14rem;
    line-height: 0.2rem;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.22rem 0.19rem;
    .van-btn-01,
    .van-btn-02 {
      width: 1.04rem;
      line-height: 0.32rem;
      height: 0.32rem;
      border-radius: 0.16rem;
    }
    .van-btn-01 {
      color: rgba(252, 3, 36, 1);
      border-color: rgba(252, 3, 36, 1);
    }
    .van-btn-02 {
      background-color: #fc0324;
    }
  }
}
</style>
<style lang="scss">
.addressList {
  .van-radio__label {
    flex: 1;
    -webkit-flex: 1;
    -o-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopcart/addressChoose.vue